(function () {
  'use strict';

  var LB = {
    images: [],
    index: 0,
    isOpen: false,

    // Zoom / pan state
    scale: 1,
    ox: 0,
    oy: 0,

    // Mouse drag
    isDragging: false,
    didDrag: false,
    _dragOx: 0,
    _dragOy: 0,
    _dragStartX: 0,
    _dragStartY: 0,

    // Touch
    _pinching: false,
    _pinchStartDist: 0,
    _pinchStartScale: 1,
    _pinchStartOx: 0,
    _pinchStartOy: 0,
    _pinchMidX: 0,
    _pinchMidY: 0,
    _swipeStartX: 0,
    _panStartOx: 0,
    _panStartOy: 0,
    _panStartX: 0,
    _panStartY: 0,

    // DOM
    el: null,
    imgEl: null,
    imgWrap: null,
    counterEl: null,
    prevBtn: null,
    nextBtn: null,

    init: function () {
      this._build();
      this._bindGallery();
    },

    _build: function () {
      var self = this;
      var el = document.createElement('div');
      el.className = 'pdp-lightbox';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');

      /* Structure:
         backdrop (click to close)
         close button (absolute top-right)
         content row: [nav-prev] [img-wrap] [nav-next]  (flex)
         counter (absolute bottom-center)
      */
      el.innerHTML =
        '<div class="pdp-lightbox__backdrop"></div>' +
        '<button class="pdp-lightbox__close" aria-label="Close">' +
          '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
            '<line x1="17" y1="5" x2="5" y2="17"/>' +
            '<line x1="5" y1="5" x2="17" y2="17"/>' +
          '</svg>' +
        '</button>' +
        '<div class="pdp-lightbox__content">' +
          '<button class="pdp-lightbox__nav pdp-lightbox__nav--prev" aria-label="Previous image">' +
            '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<polyline points="15 18 9 12 15 6"/>' +
            '</svg>' +
          '</button>' +
          '<div class="pdp-lightbox__img-wrap">' +
            '<img class="pdp-lightbox__img" src="" alt="" draggable="false">' +
          '</div>' +
          '<button class="pdp-lightbox__nav pdp-lightbox__nav--next" aria-label="Next image">' +
            '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
              '<polyline points="9 18 15 12 9 6"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<div class="pdp-lightbox__counter"></div>';

      document.body.appendChild(el);
      this.el = el;
      this.imgEl = el.querySelector('.pdp-lightbox__img');
      this.imgWrap = el.querySelector('.pdp-lightbox__img-wrap');
      this.counterEl = el.querySelector('.pdp-lightbox__counter');
      this.prevBtn = el.querySelector('.pdp-lightbox__nav--prev');
      this.nextBtn = el.querySelector('.pdp-lightbox__nav--next');

      // Backdrop → close
      el.querySelector('.pdp-lightbox__backdrop').addEventListener('click', function () {
        self.close();
      });

      // Close button
      el.querySelector('.pdp-lightbox__close').addEventListener('click', function () {
        self.close();
      });

      // Prev / Next
      this.prevBtn.addEventListener('click', function () { self.prev(); });
      this.nextBtn.addEventListener('click', function () { self.next(); });

      // Image click → zoom toggle (mouse)
      this.imgWrap.addEventListener('click', function () {
        if (self.didDrag) { self.didDrag = false; return; }
        if (self.scale > 1) {
          self._resetZoom();
        } else {
          self._zoomToScale(2.5);
        }
      });

      // Mouse drag for panning
      this.imgWrap.addEventListener('mousedown', function (e) { self._onMouseDown(e); });
      document.addEventListener('mousemove', function (e) { self._onMouseMove(e); });
      document.addEventListener('mouseup', function () { self._onMouseUp(); });

      // Touch
      this.imgWrap.addEventListener('touchstart', function (e) { self._onTouchStart(e); }, { passive: false });
      this.imgWrap.addEventListener('touchmove', function (e) { self._onTouchMove(e); }, { passive: false });
      this.imgWrap.addEventListener('touchend', function (e) { self._onTouchEnd(e); });

      // Keyboard
      document.addEventListener('keydown', function (e) {
        if (!self.isOpen) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'ArrowLeft') self.prev();
        if (e.key === 'ArrowRight') self.next();
      });
    },

    _bindGallery: function () {
      var self = this;

      // Desktop: each image in .large-image-container
      document.querySelectorAll('.large-image-container > div').forEach(function (wrap, i) {
        var img = wrap.querySelector('img');
        if (!img) return;
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function () {
          self._collect('desktop');
          self.open(i);
        });
      });

      // Mobile: delegate from swiper container
      var swiperEl = document.querySelector('.pdp-media');
      if (swiperEl) {
        swiperEl.addEventListener('click', function (e) {
          var wrapper = e.target.closest('.product_photo-wrapper');
          if (!wrapper) return;
          e.preventDefault();
          self._collect('mobile');
          var swiper = swiperEl.swiper;
          self.open(swiper ? swiper.realIndex : 0);
        });
      }
    },

    _collect: function (source) {
      this.images = [];
      var self = this;
      var sel = source === 'desktop'
        ? '.large-image-container > div img'
        : '.pdp-media .swiper-slide:not(.swiper-slide-duplicate) .product_photo-wrapper img';

      document.querySelectorAll(sel).forEach(function (img) {
        var zoomEl = img.closest('[data-zoom-src]');
        self.images.push({
          src: zoomEl ? zoomEl.dataset.zoomSrc : self._hqSrc(img),
          alt: img.alt || ''
        });
      });
    },

    _hqSrc: function (img) {
      var best = { url: img.src, w: 0 };
      (img.getAttribute('srcset') || '').split(',').forEach(function (s) {
        var parts = s.trim().split(/\s+/);
        var w = parseInt(parts[1]) || 0;
        if (w > best.w) best = { url: parts[0], w: w };
      });
      if (best.w > 0) {
        return best.url.replace(/(_\d+x\d*)(\.(?:jpg|jpeg|png|webp))/i, '_1600x$2');
      }
      return img.src;
    },

    open: function (idx) {
      this.index = Math.max(0, Math.min(idx, Math.max(0, this.images.length - 1)));
      this._resetZoom();
      this._render();
      this.el.classList.add('is-open');
      this.isOpen = true;
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      this.el.classList.remove('is-open');
      this.isOpen = false;
      this._resetZoom();
      document.body.style.overflow = '';
    },

    prev: function () {
      if (!this.images.length) return;
      this._resetZoom();
      this.index = (this.index - 1 + this.images.length) % this.images.length;
      this._render();
    },

    next: function () {
      if (!this.images.length) return;
      this._resetZoom();
      this.index = (this.index + 1) % this.images.length;
      this._render();
    },

    _render: function () {
      var item = this.images[this.index];
      if (!item) return;
      this.imgEl.src = item.src;
      this.imgEl.alt = item.alt;
      var multi = this.images.length > 1;
      this.prevBtn.style.display = multi ? '' : 'none';
      this.nextBtn.style.display = multi ? '' : 'none';
      this.counterEl.textContent = multi ? (this.index + 1) + ' / ' + this.images.length : '';
    },

    _zoomToScale: function (s) {
      this.scale = s;
      this.ox = 0;
      this.oy = 0;
      this.imgWrap.classList.add('is-zoomed');
      this._applyTransform();
    },

    _resetZoom: function () {
      this.scale = 1;
      this.ox = 0;
      this.oy = 0;
      if (this.imgEl) this.imgEl.style.transform = '';
      if (this.imgWrap) this.imgWrap.classList.remove('is-zoomed', 'is-dragging');
    },

    _applyTransform: function () {
      this.imgEl.style.transform =
        'scale(' + this.scale + ') translate(' + this.ox + 'px, ' + this.oy + 'px)';
    },

    // ── Mouse drag ──────────────────────────────────────────────────
    _onMouseDown: function (e) {
      if (this.scale <= 1 || e.button !== 0) return;
      e.preventDefault();
      this.isDragging = true;
      this.didDrag = false;
      this._dragOx = this.ox;
      this._dragOy = this.oy;
      this._dragStartX = e.clientX;
      this._dragStartY = e.clientY;
      this.imgWrap.classList.add('is-dragging');
    },

    _onMouseMove: function (e) {
      if (!this.isDragging) return;
      var dx = (e.clientX - this._dragStartX) / this.scale;
      var dy = (e.clientY - this._dragStartY) / this.scale;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) this.didDrag = true;
      this.ox = this._dragOx + dx;
      this.oy = this._dragOy + dy;
      this._applyTransform();
    },

    _onMouseUp: function () {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.imgWrap.classList.remove('is-dragging');
    },

    // ── Touch ────────────────────────────────────────────────────────
    _pinchDist: function (t) {
      var dx = t[0].clientX - t[1].clientX;
      var dy = t[0].clientY - t[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    },

    _onTouchStart: function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        this._pinching = true;
        this._pinchStartDist = this._pinchDist(e.touches);
        this._pinchStartScale = this.scale;
        this._pinchMidX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        this._pinchMidY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        this._pinchStartOx = this.ox;
        this._pinchStartOy = this.oy;
      } else if (e.touches.length === 1) {
        this._pinching = false;
        this._swipeStartX = e.touches[0].clientX;
        this._panStartX = e.touches[0].clientX;
        this._panStartY = e.touches[0].clientY;
        this._panStartOx = this.ox;
        this._panStartOy = this.oy;
      }
    },

    _onTouchMove: function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        var newDist = this._pinchDist(e.touches);
        var newScale = Math.max(1, Math.min(5, this._pinchStartScale * (newDist / this._pinchStartDist)));
        var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        this.scale = newScale;
        this.ox = this._pinchStartOx + (midX - this._pinchMidX) / newScale;
        this.oy = this._pinchStartOy + (midY - this._pinchMidY) / newScale;
        if (newScale > 1) this.imgWrap.classList.add('is-zoomed');
        this._applyTransform();
      } else if (e.touches.length === 1 && this.scale > 1) {
        e.preventDefault();
        this.ox = this._panStartOx + (e.touches[0].clientX - this._panStartX) / this.scale;
        this.oy = this._panStartOy + (e.touches[0].clientY - this._panStartY) / this.scale;
        this._applyTransform();
      }
    },

    _onTouchEnd: function (e) {
      // 2-finger → 1-finger: re-anchor pan so the remaining finger doesn't snap
      if (e.touches.length === 1) {
        this._pinching = false;
        this._panStartX = e.touches[0].clientX;
        this._panStartY = e.touches[0].clientY;
        this._panStartOx = this.ox;
        this._panStartOy = this.oy;
        return;
      }

      // All fingers lifted
      if (this._pinching) {
        this._pinching = false;
        if (this.scale < 1.05) this._resetZoom();
        return;
      }

      // Swipe to navigate when not zoomed
      if (this.scale <= 1 && e.changedTouches.length === 1) {
        var dx = e.changedTouches[0].clientX - this._swipeStartX;
        if (Math.abs(dx) > 50) {
          if (dx < 0) this.next();
          else this.prev();
        }
      }
    }
  };

  // ── "Pinch to zoom" toast (mobile) ──────────────────────────────────
  function initPinchToast() {
    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (!isTouch) return;

    var toast = document.createElement('div');
    toast.className = 'pdp-pinch-toast';
    // Expand / zoom icon
    toast.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<polyline points="15 3 21 3 21 9"/>' +
        '<polyline points="9 21 3 21 3 15"/>' +
        '<line x1="21" y1="3" x2="14" y2="10"/>' +
        '<line x1="3" y1="21" x2="10" y2="14"/>' +
      '</svg>' +
      'Pinch to zoom';

    document.body.appendChild(toast);

    var shown = false;
    var target = document.querySelector('.pdp-media') || document.querySelector('.large-image-container');
    if (!target) return;

    target.addEventListener('touchstart', function () {
      if (shown) return;
      shown = true;
      toast.classList.add('is-visible');
      setTimeout(function () { toast.classList.remove('is-visible'); }, 1600);
    }, { once: true, passive: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    LB.init();
    initPinchToast();
  });

  // Exposed so other templates (e.g. landing pages) can open the same lightbox
  // against a gallery that isn't rendered via .large-image-container/.pdp-mobile-slider.
  window.PDPLightbox = LB;
})();
